import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const SupportPlatforms = () => {

    const navigate = useNavigate();
  const platforms = [
    'Bluebook',
    'Respondus LockDown Browser',
    'Respondus Monitor',
    'ProctorU (Examity)',
    'Honorlock',
    'ExamSoft (Examplify)',
    'Proctorio',
    'Mettl (Mercer)'
  ];

  return (
    <section className="platforms-section">
        <h2 className="section-title">Supported Platforms</h2>
            <p className="section-subtitle">
                ExamGuard is compatible with all major examination platforms
            </p>
            
            <div className="platforms-grid">
                {[
                { name: 'Bluebook', desc: 'College Board', icon: 'BB' },
                { name: 'Respondus LockDown Browser', desc: 'LockDown', icon: 'RB' },
                { name: 'Respondus Monitor', desc: 'Automated Proctoring', icon: 'RM' },
                { name: 'ProctorU (Examity)', desc: 'Live Proctoring', icon: 'PU' },
                { name: 'Honorlock', desc: 'Automated + Live', icon: 'HL' },
                { name: 'ExamSoft (Examplify)', desc: 'Secure Testing', icon: 'ES' },
                { name: 'Proctorio', desc: 'AI Proctoring', icon: 'PR' },
                { name: 'Mettl (Mercer)', desc: 'Online Assessments', icon: 'MT' },
                ].map((platform, index) => (
                <div key={index} className="platform-card">
                    <div className="platform-icon">{platform.icon}</div>
                    <div className="platform-info">
                    <div className="platform-name">{platform.name}</div>
                    <div className="platform-desc">{platform.desc}</div>
                    </div>
                </div>
                ))}
            </div>
            
            <div className="platforms-cta">
                <h3>Using a different platform?</h3>
                <p>
                If your institution uses a platform not listed above, please create a ticket 
                in the support channel so our team can evaluate compatibility. We're here to 
                help you take your exams without any issues.
                </p>
                <button 
                    className="btn-support"
                    onClick={() => navigate('/dashboard')}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                    </svg>
                    Create Support Ticket
                </button>
        </div>
    </section>
  );
};

export default SupportPlatforms;